'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = galleryReducer;

var _galleryTypes = require('../constants/galleryTypes.js');

var _videoActionTypes = require('../constants/videoActionTypes');

var _videoActionTypes2 = _interopRequireDefault(_videoActionTypes);

var _itemViewActions = require('../actions/itemViewActions.js');

var _initialState = require('./initialState.js');

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function galleryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.gallery;
  var action = arguments[1];

  switch (action.type) {
    case _galleryTypes.SET_WIX_DATA:
      if (action.boundingRectAndOffsets) {
        var res = action.boundingRectAndOffsets;
        var scrollBase = res.offsets.y;
        var scrollTop = -1 * res.rect.top / _utils2.default.getViewportScaleRatio();
        var maxGalleryWidth = void 0;
        if (res && res.rect && !_lodash2.default.isUndefined(res.rect.width)) {
          maxGalleryWidth = res.rect.width;
        }

        return _lodash2.default.merge({}, state, {
          wixInit: true,
          scrollBase: scrollBase,
          scrollTop: scrollTop,
          maxGalleryWidth: maxGalleryWidth
        });
      } else {
        return _lodash2.default.merge({}, state, {
          wixInit: true,
          scrollBase: 0
        });
      }

    case _videoActionTypes2.default.videoModeChanged:
      {
        var newVideoPlayMode = action.payload;
        var _state = state,
            videoPlayMode = _state.videoPlayMode;

        if (videoPlayMode !== newVideoPlayMode) {
          state = (0, _extends3.default)({}, state, { videoPlayMode: newVideoPlayMode });
        }

        break;
      }
    case _galleryTypes.SET_ITEMS:
      return _lodash2.default.merge({}, state, { items: action.items });
    case _galleryTypes.SET_RENDERED_ITEMS_COUNT:
      return _lodash2.default.merge({}, state, { renderedItemsCount: action.count });
    case _galleryTypes.GALLERY_WINDOW_LAYOUT_CHANGED:
      {
        var documentHeight = { documentHeight: action.documentHeight };
        return _lodash2.default.merge({}, state, documentHeight);
      }
    case _galleryTypes.SET_VIDEO_PLAY_INDEX:
      if (state.isInView) {
        state = (0, _extends3.default)({}, state, { videoIndexPlay: action.payload, lastVideoPlayed: action.payload });
      }
      break;
    case _itemViewActions.PLAY_VIDEO:
      if (state.isInView) {
        return _lodash2.default.merge({}, state, { videoIndexPlay: action.idx, lastVideoPlayed: action.idx });
      }
      break;
    case _itemViewActions.PAUSE_VIDEO:
      return _lodash2.default.merge({}, state, { videoIndexPlay: -1 });
    case _galleryTypes.TOGGLE_HOVER_PREVIEW:
      return _lodash2.default.merge({}, state, { previewHover: action.toggle });
    case _galleryTypes.TOGGLE_ISINVIEW:
      return _lodash2.default.merge({}, state, { isInView: action.toggle });
    default:
      return state;
  }

  return state;
}